/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const GenerationStatusResponseStatusEnum = {
    completed: 'completed',
    failed: 'failed',
    pending: 'pending'
};
/**
 * Check if a given object implements the GenerationStatusResponse interface.
 */
export function instanceOfGenerationStatusResponse(value) {
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    return true;
}
export function GenerationStatusResponseFromJSON(json) {
    return GenerationStatusResponseFromJSONTyped(json, false);
}
export function GenerationStatusResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'createdAt': (new Date(json['created_at'])),
        'errorCode': json['error_code'] == null ? undefined : json['error_code'],
        'generatedText': json['generated_text'] == null ? undefined : json['generated_text'],
        'status': json['status'],
    };
}
export function GenerationStatusResponseToJSON(json) {
    return GenerationStatusResponseToJSONTyped(json, false);
}
export function GenerationStatusResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'created_at': value['createdAt'].toISOString(),
        'error_code': value['errorCode'],
        'generated_text': value['generatedText'],
        'status': value['status'],
    };
}
